module.exports = __webpack_public_path__ + "static/media/StrelitziaImg.2211adec.webp";